import React from 'react';
import MarketingLayout from '../components/MarketingLayout';

const sections = [
    ['Use of service', 'Restaurants are responsible for menu accuracy, prices, availability, offers, and customer communication through the platform.'],
    ['Orders and payments', 'The platform facilitates order management and integrates with verified payment gateways. All transactions are processed securely through certified payment partners.'],
    ['Subscriptions', 'Starter, Growth, Pro, and Enterprise plans control feature access. Subscriptions are billed according to the selected billing cycle with secure payment processing and automated renewal.'],
    ['Content ownership', 'Restaurants retain full ownership of uploaded logos, dish images, menu names, prices, and descriptions.'],
    ['Operational responsibility', 'Restaurant staff should review live orders, printed receipts, order status, and customer instructions before service. GetYourQR is a platform facilitator and does not assume liability for order fulfillment.'],
];

export default function TermsPage() {
    return (
        <MarketingLayout>
            <main className="mx-auto max-w-4xl px-4 py-16 lg:px-8">
                <p className="section-title">Terms</p>
                <h1 className="mt-3 text-5xl font-black tracking-tight">Terms & Conditions</h1>
                <p className="mt-4 text-sm font-medium leading-6 text-slate-500">
                    By using GetYourQR, you agree to the following terms governing platform usage, subscriptions, and content ownership.
                </p>
                <div className="mt-8 grid gap-4">
                    {sections.map(([title, text]) => (
                        <section key={title} className="card">
                            <h2 className="text-xl font-black">{title}</h2>
                            <p className="mt-2 text-sm font-medium leading-6 text-slate-500">{text}</p>
                        </section>
                    ))}
                </div>
            </main>
        </MarketingLayout>
    );
}
